<template>
  <a href="#" @click="callNegoce">
    <v-ons-icon icon="fa-phone"></v-ons-icon>&nbsp;
    <span>Appeler {{ tcInfos && tcInfos.label ? tcInfos.label : 'mon OS' }}</span>
    <span style="display: inline-block">
      <img v-for="img in (tcInfos && tcInfos.imgs ? tcInfos.imgs : [])" :key="img"
          :src="$apiDomain + '/imgs/negoce/tc/' + img + '.png'" />
    </span>
  </a>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

export default {
  mixins: [mixinsCommons],
  props: ['negoceInfos', 'trackInfos', 'isAppro'],
  data() {
    return {
      state: store.state
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    tel() {
      return this.isAppro && this.negoceInfos.tel_appro ? this.negoceInfos.tel_appro : this.negoceInfos.tel;
    },
    tcInfos() {
      return this.isAppro && this.negoceInfos.tc_appro ? this.negoceInfos.tc_appro : this.negoceInfos.tc;
    }
  },
  methods: {
    callNegoce() {
      this.sendTrackEvent('negoce call ' + this.negoceInfos.id + ' ' + this.trackInfos);
      this.$callTel(this.tel);
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
a span {
  text-decoration: underline;
}
</style>

<style>
.list-item--perfbutton__center a,
.footer--perfbutton a {
  margin: 0 auto 18px;
}
.footer--perfbutton a {
  display: table;
}
.footer--perfbutton .button--perflarge + a {
  margin-top: 20px;
}
.list-item--perfbutton__center img,
.footer--perfbutton img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-left: 5px;
  margin-bottom: -14px;
}
</style>